module.exports = __webpack_public_path__ + "img/parameter.00da2e41.png";